import { IconInfoOutlined } from '@prisjakt/ui/icon';
import { Tooltip as TooltipComponent } from '@prisjakt/ui/tooltip';
import PrisjaktIconComponent from 'src/components/prisjakt-icon';
import styled, { css } from 'styled-components';
import { OurChoiceWrapperProps } from '.';

export const withOurChoiceStyles = (
  Component: React.FC<OurChoiceWrapperProps>
) => styled(Component)`
  border: 1px solid ${p => p.theme.colors.positive500};
  ${p =>
    p.withShadow &&
    css`
      box-shadow: 0px 2px 4px 0px #05252e3d;
    `}
`;

export const Wrapper = styled.div<{ $withShadow?: boolean }>`
  position: relative;
  pointer-events: auto;
`;

export const Ribbon = styled.div`
  width: 32px;
  height: 24px;
  background-color: ${p => p.theme.colors.positive500};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  pointer-events: none;
`;

export const IconWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: none;
`;

export const InfoIcon = styled(IconInfoOutlined)`
  vertical-align: middle;
`;

export const Tooltip = styled(TooltipComponent)`
  display: inline-block;
`;

export const PrisjaktIcon = styled(PrisjaktIconComponent)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;
